<template>
    <div>
        <section class="bg-blue">
            <div class="education-loan-form bg-white col-md-6 col-md-offset-3" id="sd">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-start questionnaire-form-start">
                            <form id="questionnaire-form" @submit.prevent="submitFormData()">
                                <div class="col-md-12">
                                    <h1 class="main-heading">Please Fill this Questionnaire</h1>
                                </div>
                                <div class="col-md-12 padd-20" v-for="field in data">
                                    <div class="form-group" v-if="field.field_type === 'radio'">
                                        <div class="radio-heading input-group-text">
                                            {{ field.field_label }}
                                        </div>
                                        <ul class="displayInline">
                                            <li v-for="rlist in field.questionnaireFieldOptions">
                                                <label class="container-radio" :for="rlist.field_option_enc_id">
                                                    {{ rlist.field_option }}
                                                    <input type="radio" :name="field.field_enc_id"
                                                           :id="rlist.field_option_enc_id"
                                                           :value="rlist.field_option_enc_id" class="co-field"
                                                           :class="((field.is_required == '1') ? 'field-req' : '')">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="form-group checkboxesMain" v-else-if="field.field_type === 'checkbox'">
                                        <div class="radio-heading input-group-text">
                                            {{ field.field_label }}
                                        </div>
                                        <ul>
                                            <li class="service-list" v-for="clist in field.questionnaireFieldOptions">
                                                <input type="checkbox" :name="field.field_enc_id"
                                                       :id="clist.field_option_enc_id"
                                                       class="checkbox-input services co-field check-field"
                                                       :value="clist.field_option_enc_id"
                                                       :class="((field.is_required == '1') ? 'field-req' : '')"/>
                                                <label :for="clist.field_option_enc_id">{{ clist.field_option }}</label>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="form-group" v-else-if="field.field_type === 'textarea'">
                                        <label :for="field.field_enc_id" class="input-group-text">
                                            {{ field.field_label }}
                                        </label>
                                        <textarea :id="field.field_enc_id" :name="field.field_enc_id" type="textarea"
                                                  class="form-control dash-input" rows="4"
                                                  :class="((field.is_required == '1') ? 'field-req' : '')"></textarea>
                                    </div>
                                    <div class="form-group" v-else-if="field.field_type === 'select'">
                                        <label :for="field.field_enc_id" class="input-group-text">
                                            {{ field.field_label }}
                                        </label>
                                        <select class="form-control" type="select" :id="field.field_enc_id"
                                                :name="field.field_enc_id"
                                                :class="((field.is_required == '1') ? 'field-req' : '')">
                                            <option value="">Select {{ field.field_label }}</option>
                                            <option v-for="slist in field.questionnaireFieldOptions"
                                                    :value="slist.field_option_enc_id">{{ slist.field_option }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group" v-else>
                                        <label :for="field.field_enc_id" class="input-group-text">
                                            {{ field.field_label }}
                                        </label>
                                        <input :type="field.field_type" class="form-control" :id="field.field_enc_id"
                                               :placeholder="field.placeholder" :name="field.field_enc_id"
                                               :class="((field.is_required == '1') ? 'field-req' : '')">
                                    </div>
                                </div>
                                <div class="input-group padd-20">
                                    <div class="btn-center">
                                        <button type="submit" class="button-slide">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import toastr from "../../../public/js/toastr";
import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

export default {
    data: function () {
        return {
            valid: false,
            data: [],
        }
    },
    methods: {
        validateForm: function () {
            var x, y, z, i, valid = true, a = this;
            x = document.getElementById("questionnaire-form");
            y = x.getElementsByClassName("field-req");
            for (i = 0; i < y.length; i++) {
                if (y[i].value == "") {
                    y[i].className += " invalid";
                    valid = false;
                } else {
                    y[i].classList.remove('invalid');
                }
            }
            return valid;
        },
        getQuestionnaire() {
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/candhome/questionnaire-fields`, {
                questionnaire_enc_id: t.$route.query.id,
                applied_application_enc_id: t.$route.query.aid
            }, {
                headers: requestHeaders()
            }).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.data = response['data']['response']['data'];
                } else if (response['data']['response']['status'] == 409) {
                    alert('Questionnaire already filled.');
                    t.$router.push({path: '/dashboard'});
                } else {
                    t.$router.push({path: '/dashboard'});
                    alert('Oops!! Something went wrong. Please try again.');
                }
            })
                .catch(function (error) {
                    alert('your Internet Connection Unstable');
                    location.reload();
                })
        },
        submitFormData() {
            var t = this;
            if (!t.validateForm()) {
                alert('Please Answer all Required fields');
                return false;
            }
            var elements = document.getElementById('questionnaire-form').elements;
            var obj = {};
            var dataArr = [];
            for (var i = 0; i < elements.length; i++) {
                var elemData = {};
                var item = elements.item(i);
                var type = item.getAttribute('type');
                if (type == 'select') {
                    elemData['option_enc_id'] = item.value;
                }
                if (type != 'radio' && type != 'checkbox') {
                    elemData['field_enc_id'] = item.name;
                    elemData['field_type'] = item.getAttribute('type');
                    elemData['answer'] = item.value;
                } else if (type == 'radio') {
                    if (item.checked) {
                        elemData['field_enc_id'] = item.name;
                        elemData['field_type'] = item.getAttribute('type');
                        elemData['answer'] = item.value;
                        elemData['option_enc_id'] = item.value;
                    }
                }
                if (elemData['field_enc_id']) {
                    dataArr.push(elemData);
                }
            }
            var checkboxes = document.getElementsByClassName('checkboxesMain');
            for (var g = 0; g < checkboxes.length; g++) {
                var checkboxElements = checkboxes[g].querySelectorAll('.check-field');
                var elemData2 = {};
                var checkedElemData = [];
                for (var h = 0; h < checkboxElements.length; h++) {
                    var item2 = checkboxElements.item(h);
                    if (item2.checked) {
                        checkedElemData.push(item2.value)
                    }
                }
                if (checkedElemData.length) {
                    elemData2['field_enc_id'] = item2.name;
                    elemData2['field_type'] = item2.getAttribute('type');
                    elemData2['answer'] = item2.value;
                    elemData2['options'] = checkedElemData;
                }
                if (elemData2['field_enc_id']) {
                    dataArr.push(elemData2);
                }
            }
            obj['questionnaire_enc_id'] = t.$route.query.id;
            obj['applied_application_enc_id'] = t.$route.query.aid;
            obj['data'] = dataArr;
            var url = this.$store.getters.getDomain;

            showLoader();
            axios.post(`${url}api/v2/candhome/fill-questionnaire`, obj, {headers: requestHeaders()})
                .then(res => {
                    hideLoader();
                    if (res['data']['response']['status'] == 200) {
                        toastr.success('Questionnaire Filled Successfully', 'Saved');
                        t.$router.push({path: '/dashboard'});
                    } else {
                        toastr.error('Something went wrong. Please try again.', 'Oops!!');
                    }
                }).catch(function (error) {
                hideLoader();
                toastr.error('Something went wrong. Please try again.', 'Oops!!');
            })
        },
    },
    mounted() {
        var t = this;
        t.getQuestionnaire();
    },
}
</script>

<style scoped>
.questionnaire-form-start{
    box-shadow: 0px 2px 8px 0px #ddd;
    padding: 10px 20px;
    max-width: 600px;
}

.displayInline li {
    display: inline-block;
    padding-right: 20px;
}

.form-start {
    max-width: 550px;
    margin: 0 auto;
}

.btn-center {
    text-align: center;
}

.btn-center button {
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    padding: 13px 32px;
    border-radius: 4px;
    -o-transition: .3s all;
    -ms-transition: .3s all;
    -moz-transition: .3s all;
    -webkit-transition: .3s all;
    transition: .3s all;
    color: #fff;
    box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
    margin-left: 5px;
    background: #00a0e3;
    border: none;
}

.btn-center button:hover {
    background-color: #fff;
    color: #222;
}

.education-loan-form {
    padding: 20px 25px 0 25px;
    background: linear-gradient(to bottom, #e9f5f5 0%, #fefefe 100%);
    min-height: 100%;
    min-height: 100vh;
}
.bg-white {
    background: #fff;
}

.radio-heading {
    padding-bottom: 10px;
}

.input-group {
    width: 100%;
}

.form-group {
    margin-bottom: 20px;
}

.form-control.invalid {
    border: 1px solid #ff0000;
}

.college-list {
    z-index: 99 !Important;
}
</style>